<template>
  <div class="">
      <!-- Link Chooser
      This shows a link that lets the user edit the value in for example:

        http://smartkidsmarket.com/ ___________________
       -->

      <v-layout align-center justify-center row fill-height :class="itemClass">
        <v-icon v-if="icon" class="ma-1 mr-3">{{icon}}</v-icon>

        <span>
          {{ baseLink }}
        </span>
        <v-text-field
          v-bind:value="value"
          v-on:change="updateLink($event)"
          type="text"
          :rules="nameRules"
          :required="isRequired"
          :loading="inprogress"
          :error="errMessage != null"
          :error-messages=[errMessage]
        ></v-text-field>
      </v-layout>

</div>

</template>

<script>
import {mapState} from 'vuex'
import utils from '../../../utils.ts'
import config from '../../../config.js'

export default {
  name: 'LinkChooser',
  components: {
  },
  props: {
    baseLink: String,
    isRequired: {
      required: false,
      default: false,
      type: Boolean
    },
    icon: {
      required: false,
      default: null,
      type: String
    },
    linkName: {
      required: true,
      type: String
    }

  },
  data () {
    return {
      valid: false,
      nameRules: [
        utils.minLength(1, 'Link name must be at least 3 characters long'),
        utils.maxLength(100, 'Link name cannot be more than 100 characters long'),
        utils.validChars(/^[A-Za-z0-9-_]+$/, 'Site name can only have letters, numbers and underscores.')
      ],
      errMessage: null,
      inprogress: false,
      updateSuccess: false
    }
  },
  computed: {
    ...mapState({
      value (state) {
        return state.admin.public_settings[this.linkName]
      },
      locked: state => state.admin.public_settings.locked,
    }),
    itemClass: function () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 'body-1'
      } else {
        return 'title'
      }
    }

  },
  methods: {
    updateLink: async function (event) {
      // Update the password
      this.inprogress = true
      this.errMessage = null
      this.updateSuccess = false

      // console.log('UPDATING LINK ' + this.linkName + '   to  ' + event)
      try {
        if (this.locked) {
            throw new Error("Acount is locked. You cannot make any changes.")
        }

        // Now link them and charge the account
        var updateSocialLink = config.getFunctions().httpsCallable('updateSocialLink')
        await updateSocialLink(
          {
            name: this.linkName,
            val: event
          }
        )

        this.updateSuccess = true
      } catch (err) {
        console.error('Could not change name: ' + JSON.stringify(err))
        this.errMessage = err.message
      }

      this.inprogress = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
